import React from 'react';

import FileList from './FileList';
import Aggregator from './Aggregator';
import DownloadButton from './DownloadButton';
import WhenOfflineMode from './WhenOfflineMode';
import MediaIDCollector from './MediaIDCollector';

export {
    FileList,
    Aggregator,
    DownloadButton,
    WhenOfflineMode,
    MediaIDCollector,
};

const Wrapper = props => (
    <WhenOfflineMode>
        <MediaIDCollector {...props}>
            <FileList>
                <Aggregator>
                    <DownloadButton />
                </Aggregator>
            </FileList>
        </MediaIDCollector>
    </WhenOfflineMode>
);

export default Wrapper;



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/DownloadButton/index.js